<form *ngIf="fields && addEditForm" [formGroup]="addEditForm" (ngSubmit)="saveOrUpdate()" [ngClass]="{'invalid-submit': invalidSubmit}" RestrictFocus>

  <div class="ui-g ui-fluid">

    <div class="ui-g-12 ui-md-12">
      <span class="label" [ngClass]="{'required': !fields.layout_id.nullable}">{{ fields.layout_id.keyName }}</span>
      <p-dropdown [options]="layoutList" formControlName="layout_id" [style]="{'width':'100%'}"></p-dropdown>
      <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="fields.layout_id"></app-validation-msg>
    </div>

    <div class="ui-g-12 ui-md-12">
      <span class="label" [ngClass]="{'required': !fields.description_fe.nullable}">{{ fields.description_fe.keyName }}</span>
      <input type="text" pInputText class="fieldInput" formControlName="description_fe"/>
      <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="fields.description_fe"></app-validation-msg>
    </div>

    <div class="ui-g-12 ui-md-12">
      <span class="label" [ngClass]="{'required': !fields.description_fe.nullable}">{{ fields.format_string.keyName }}</span>
      <input type="text" pInputText class="fieldInput" formControlName="format_string"/>
      <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="fields.format_string"></app-validation-msg>
    </div>

  </div>

  <p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <br />
      <button class="k-generic-btn" type="submit" pButton icon="fa fa-check"
              label="{{layoutObj ? ('common.edit' | translate) :  ('common.add' | translate) }}">
      </button>
    </div>
  </p-footer>

</form>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-acm/form-acm-loyalty/layoutForm.html